let apiBaseUrl = '';
let photoUpApi = '';

// API域名
if (process.env.NODE_ENV === 'development') {
  apiBaseUrl = 'http://merchantadminapi.jp.dev.instatech.cn/v1';
  photoUpApi = 'http://file.jp.dev.instatech.cn/v1';
} else if (process.env.NODE_ENV === 'production') {
  apiBaseUrl = 'http://merchantadminapi.jp.dev.instatech.cn/v1';
  photoUpApi = 'http://file.jp.dev.instatech.cn/v1';
}

//  定义路由模式
const ROUTERMODE = 'history'

// 签名密钥
const SIGN_KEY = '8UfkRWocQr6vjgv9';
// 加密密钥
const ENCRYPT_KEY = '7yaYA368XgqJc4X7';
// 加密新密钥
const ENCRYPT1_KEY = 'getOffline()';

// 二维码秘钥
const SHOP_CODE = 'getOffline()';

//google key
const GOOGLE_KEY = 'AIzaSyDuXUR16Q0K6U66HauUjPPxVrwLtS_hAyg';

//压缩图片到指定大小
const IMG_FILE_SIZE = 2048; //(2048kb等于2m)

export {
  apiBaseUrl,
  photoUpApi,
  SIGN_KEY,
  ENCRYPT_KEY,
  ROUTERMODE,
  GOOGLE_KEY,
  SHOP_CODE,
  IMG_FILE_SIZE,
  ENCRYPT1_KEY
}